import { render, staticRenderFns } from "./ActivityFeedSection.vue?vue&type=template&id=3380411c&scoped=true&"
import script from "./ActivityFeedSection.vue?vue&type=script&lang=js&"
export * from "./ActivityFeedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380411c",
  null
  
)

export default component.exports